import React from "react"

export default class BookingSignInForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = { showPassword: false}
  }

  render() {
    if (this.props.forgot_password_visible) {
      return (
        <div className="BookingSignInForm">{this.renderForgotPassword()}</div>
      )
    } else if (this.props.resend_confirmation_visible) {
      return (
        <div className="BookingSignInForm">{this.renderResendConfirmation()}</div>
      )
    } else {
      return (
        <div className="BookingSignInForm">{this.renderSignIn()}</div>
      );
    }
  }

  renderSignIn() {
    return (
      <div>
        <div className="row">
          <div className="col-sm-6">
            <div className={"form-group mb-0 " + (this.props.hasErrors ? 'has-error' : '')}>
              <label>{I18n.t('email_address')}</label>
              <input type="email" className="form-control" name="email" value={this.props.sign_in_information.email || this.props.guest_information.email || ''} onChange={this.props.onChangeSignInInformation} />
            </div>
          </div>
          <div className="col-sm-6">
            <div className={"form-group mb-0 " + (this.props.hasErrors ? 'has-error' : '')}>
              <label>{I18n.t('password')}</label>
              <input type={this.state.showPassword ? "text" : "password"} className="form-control" name="password" value={this.props.sign_in_information.password || ''} onChange={this.props.onChangeSignInInformation} />
              <span
                className={`fa fa-fw ${this.state.showPassword ? "fa-eye fa-eye-slash" : "fa-eye"
                  }`}
                onClick={this.onTogglePassword}
                style={{
                  position: "absolute",
                  cursor: "pointer",
                  top: "35px",
                  right: "25px",
                  color: "#555",
                }}
              ></span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderForgotPassword() {
    return (
      <div className="row">
        <div className="col-sm-12">
          <div className={"form-group "}>
            <label>{I18n.t('email_address')}</label>
            <input type="email" className="form-control" name="email" value={this.props.sign_in_information.email || this.props.guest_information.email || ''} onChange={this.props.onChangeSignInInformation} />
          </div>
        </div>
      </div>
    );
  }

  renderResendConfirmation() {
    return (
      <div className="row">
        <div className="col-sm-12">
          <div className={"form-group "}>
            <label>{I18n.t('email_address')}</label>
            <input type="email" className="form-control" name="email" value={this.props.sign_in_information.email || this.props.guest_information.email || ''} onChange={this.props.onChangeSignInInformation} />
          </div>
        </div>
      </div>
    );
  }

  onTogglePassword = () => { this.setState({ showPassword: !this.state.showPassword })}

}